import React from "react"

import { AlertTriangle, CheckCircle, Clock } from "lucide-react"

import { cn } from "@/lib/utils"

interface StageCardProps {
  title: string
  status: "completed" | "current" | "upcoming"
  description: string
  details?: string
}

const StageCard: React.FC<StageCardProps> = ({ title, status, description, details }) => {
  return (
    <div className="flex items-start rounded-lg border p-3 md:p-4">
      <div className="mr-3 mt-1 flex-shrink-0 md:mr-4">
        {status === "completed" && <CheckCircle className="h-5 w-5 text-green-500 md:h-6 md:w-6" />}
        {status === "current" && <Clock className="h-5 w-5 text-honeycomb md:h-6 md:w-6" />}
        {status === "upcoming" && <AlertTriangle className="h-5 w-5 text-gray-300 md:h-6 md:w-6" />}
      </div>
      <div className="min-w-0 flex-1">
        <h3
          className={cn(
            "text-sm font-medium md:text-base",
            status === "current"
              ? "text-honeycomb"
              : status === "completed"
                ? "text-green-700"
                : "text-gray-400",
          )}
        >
          {title}
        </h3>
        <p className="mt-1 text-xs text-gray-500 md:text-sm">{description}</p>
        {details && <p className="mt-1 break-words text-xs font-medium md:text-sm">{details}</p>}
      </div>
      <div className="ml-2 flex-shrink-0 md:ml-auto">
        {status === "completed" && (
          <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-1 text-[10px] font-medium text-green-800 md:text-xs">
            Completed
          </span>
        )}
        {status === "current" && (
          <span className="inline-flex items-center rounded-full bg-amber-100 px-2 py-1 text-[10px] font-medium text-amber-800 md:text-xs">
            In Progress
          </span>
        )}
      </div>
    </div>
  )
}

export default StageCard
